<template>
    <header>
        <h1>Area riservata</h1>
    </header>
    <NavBar v-bind:pages="availablePages" />
    <slot></slot>
</template>

<script setup lang="ts">
import { adminSitePages } from "~/client/adminSitePages";
import { getRoleAvailablePages } from "~/client/mainSitePages";

const auth = useAuthStore();
const availablePages = computed(() => {
    console.log(
        "[AdminLayout]",
        `Showing pages for role ${auth.authInfo?.role}`,
    );
    return getRoleAvailablePages(adminSitePages, auth.authInfo?.role);
});

const unsubscribe = useRouter().beforeEach((params) => {
    if (!params.path.startsWith("/admin")) {
        auth.logoutAsync();
        unsubscribe();
    }
});
</script>

<style scoped>
header {
    padding: var(--m-large);
}

h1 {
    text-align: center;
}
</style>
